import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { useApi } from '../contexts/ApiContext';

export default function SidebarFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tier } = useApi();
  const active = location.pathname === '/settings';

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate('/settings')}
        className="flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-sm flex-1"
        style={{
          backgroundColor: active ? 'var(--sage-surface)' : 'transparent',
          color: active ? 'var(--sage-text)' : 'var(--sage-text-muted)',
        }}
      >
        <Settings size={18} />
        Settings
      </button>
      <span
        className="text-[10px] uppercase tracking-wider px-2 py-1 rounded-full"
        style={{
          backgroundColor: tier === 'free'
            ? 'color-mix(in srgb, var(--sage-primary) 15%, transparent)'
            : 'color-mix(in srgb, var(--sage-accent) 15%, transparent)',
          color: tier === 'free' ? 'var(--sage-primary)' : 'var(--sage-accent)',
        }}
      >
        {tier}
      </span>
    </div>
  );
}
